module.exports = require('./helpers/bundle-url').getBundleURL('kxbKD') + "loc-icon--active.e554d681.svg" + "?" + Date.now();